import {NewsArticle} from '../type'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {Image} from '@/src/shared/ui/image'

import * as UI from './preview.styled'

interface IProps {
  article: NewsArticle
  showTitle?: boolean
  datePlacement?: 'left' | 'right'
}

export const NewsPreview = ({article, showTitle = true, datePlacement = 'right'}: IProps) => {
  return (
    <UI.Wrapper>
      <UI.Picture>
        {article.cover?.type === 'image' && (
          <Image
            src={`${article.cover?.src}` || noPhotoPic}
            alt={article.title}
            width={828}
            height={463}
            fetchPriority="high"
            loading="eager"
          />
        )}
        {showTitle && <UI.Title>{article.title}</UI.Title>}
        <UI.Time $left={datePlacement === 'left'}>{article.date_create_short}</UI.Time>
      </UI.Picture>
    </UI.Wrapper>
  )
}
